import React, { Component } from 'react';
import {
  ActivityIndicator,
  Alert,
  Dimensions,
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import _ from 'lodash';

import { KeyboardAwareScrollView } from '../modules';

import { updateCredential } from '../actions/user';
import Utils from '../utils/Utils';
import APIClient from '../utils/APIClient';

const contentWidth = Math.min(Dimensions.get('window').width - 40, 300);

class UpdatePasswordScreen extends Component {

  static navigationOptions = ({navigation}) => {
    const {params} = navigation.state;
    return {
      headerBackTitle: null,
      headerTitle: 'Cập nhật mật khẩu',
    };
  };

  constructor (props) {
    super(props);

    this.state = {};
  }

  componentDidMount () {
  }

  componentWillUnmount () {
  }

  _updateInputValue (name, value) {
    this.setState({
      [name]: value,
    });
  }

  _focusTextInput (name) {
    const textInput = this.refs[name];
    if (textInput) {
      textInput.focus();
    }
  }

  _submit = async () => {
    const {submitting} = this.state;
    if (submitting) {
      return;
    }

    const {password, repeatPassword} = this.state;
    var errorMessage, textInputRef;
    if (_.isEmpty(password)) {
      errorMessage = 'Vui lòng nhập mật khẩu';
      textInputRef = 'passwordTextInput';
    } else if (_.isEmpty(repeatPassword)) {
      errorMessage = 'Vui lòng nhập lại mật khẩu xác nhận';
      textInputRef = 'repeatPasswordTextInput';
    } else if (password !== repeatPassword) {
      errorMessage = 'Mật khẩu không trùng nhau, vui lòng nhập lại';
      textInputRef = 'passwordTextInput';
    }
    if (errorMessage) {
      if (Platform.OS === 'web') {
        alert(errorMessage);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          errorMessage,
          [
            {text: 'OK', onPress: () => this._focusTextInput(textInputRef)},
          ],
        );
      }
      return;
    }

    this.setState({
      submitting: true,
    });

    const data = {
      password: password,
    };
    const {response, error} = await APIClient.POST('/user/updatePassword',
      data);
    this._handleNetworkResponse(response, error);
  };

  _handleNetworkResponse (response, error) {
    /*if (response) {
      console.log(response);
    }
    if (error) {
      console.error(error);
    }*/

    this.setState({
      submitting: false,
    });

    if (response && response.response) {
      const {password} = this.state;
      const credential = {
        ...APIClient.credential,
        password: password,
      };
      this.props.updateCredential(credential);
      const message = 'Cập nhật mật khẩu thành công';
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
          [
            {text: 'OK', onPress: () => this.props.navigation.goBack()},
          ],
        );
      }
    } else {
      const message = Utils.parseErrorMessage(response, error,
        'Đăng kí thất bại, vui lòng thử lại sau');
      if (Platform.OS === 'web') {
        alert(message);
      } else {
        Alert.alert(
          global.__APP_NAME__,
          message,
        );
      }
    }
  }

  render () {
    const {password, repeatPassword, submitting} = this.state;
    return (
      <View
        style={styles.container}>
        <KeyboardAwareScrollView
          automaticallyAdjustContentInsets={false}
          keyboardDismissMode={Platform.OS === 'ios' ? 'on-drag' : 'none'}
          keyboardShouldPersistTaps='never'
          containerContentStyle={styles.contentContainer}
          style={styles.content}>

          <Text
            style={styles.inputTitleText}>
            Mật khẩu mới
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='passwordTextInput'
              value={password}
              placeholder='Mật khẩu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='none'
              returnKeyType='next'
              secureTextEntry
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('password', text)}
              onSubmitEditing={() => this._focusTextInput(
                'repeatPasswordTextInput')}/>
          </View>

          <Text
            style={styles.inputTitleText}>
            Nhập lại mật khẩu mới
          </Text>
          <View
            style={styles.input}>
            <TextInput
              ref='repeatPasswordTextInput'
              value={repeatPassword}
              placeholder='Nhập lại mật khẩu'
              placeholderTextColor='#51585ebf'
              underlineColorAndroid='transparent'
              clearButtonMode='while-editing'
              autoCapitalize='none'
              returnKeyType='send'
              secureTextEntry
              style={styles.textInput}
              onChangeText={(text) => this._updateInputValue('repeatPassword',
                text)}
              onSubmitEditing={() => this._submit()}/>
          </View>

          <TouchableOpacity
            activeOpacity={0.75}
            style={styles.submit}
            onPress={() => this._submit()}>
            <Image
              source={require('../img/btn.png')}
              style={styles.submitImage}/>
            <Text
              style={styles.submitText}>
              THAY ĐỔI MẬT KHẨU
            </Text>
            {submitting && <View
              style={styles.submitting}>
              <ActivityIndicator
                animating={true}
                color='#ffffff'
                style={styles.submittingIndicator}/>
            </View>}
          </TouchableOpacity>

        </KeyboardAwareScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6efdb',
  },
  content: {
    flex: 1,
  },
  contentContainer: {},

  inputTitleText: {
    width: contentWidth,
    marginTop: 16,
    alignSelf: 'center',
    color: '#000000',
    fontSize: 16,
    fontWeight: '300',
    backgroundColor: 'transparent',
  },
  input: {
    width: contentWidth,
    height: 44,
    marginTop: 5,
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#e2d7ba',
    backgroundColor: '#ffffff',
  },
  textInput: {
    marginLeft: 12,
    padding: 0,
    color: '#51585e',
    fontSize: 17,
    fontWeight: '300',
    backgroundColor: 'transparent',
    ...Platform.select({
      web: {
        outline: 'transparent',
      },
    }),
  },

  submit: {
    width: contentWidth,
    height: 56,
    marginTop: 12,
    marginBottom: 12,
    alignSelf: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'transparent',
  },
  submitImage: {
    position: 'absolute',
    top: 0, left: 0,
    width: contentWidth,
    height: 56,
    resizeMode: 'stretch',
  },
  submitText: {
    color: '#ffffff',
    fontSize: 20,
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    zIndex: 1,
  },
  submitting: {
    position: 'absolute',
    top: 0, bottom: 0, right: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  submittingIndicator: {},
});

const mapStateToProps = (state) => {
  return {
    credential: state.user.credential,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCredential: (credential) => dispatch(updateCredential(credential)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  UpdatePasswordScreen);



// WEBPACK FOOTER //
// ./src/profile/UpdatePasswordScreen.js